import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { AppraisalReviewStore } from '../stores/appraisalReviewStore';

export const useAppraisalReviewStore = () => useContext<{
  appraisalReviewStore: AppraisalReviewStore
}>(StoreContext);
